<template lang="pug">
  shListData(title="Deliverys History" resolver="deliveriesHistory" keyData="_id" component="shDelivery" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'DeliveriesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/delivery/DeliveriesHistory.vue